import './read-more.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSReadMore } from './read-more';

components.register({
	selector: '.gs-ReadMore',
	controller: GSReadMore
});
